import React from 'react';
import { MonitorOff } from 'lucide-react-native';
import {
  Box, HStack, Center, Text, Icon,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

interface ResolutionGuardProps {
  width: number;
  height: number;
  minWidth?: number;
  minHeight?: number;
  headerLeft: React.ReactNode;
  headerRight: React.ReactNode;
}

/**
 * Guard component that displays an error message if the screen resolution is too low.
 */
const ResolutionGuard: React.FC<ResolutionGuardProps> = ({
  width,
  height,
  minWidth = 1024,
  minHeight = 500,
  headerLeft,
  headerRight,
}) => {
  const { t } = useTranslation();

  return (
    <Box w="100%" h="100%" bg="$bgApp">
      <HStack
        h={64}
        bg="$bgApp"
        borderBottomWidth={1}
        borderBottomColor="$borderLight"
        alignItems="center"
        justifyContent="space-between"
        px="$4"
      >
        {headerLeft}
        {headerRight}
      </HStack>
      <Center flex={1} p="$8">
        <Box alignItems="center" maxWidth={400}>
          <Icon as={MonitorOff} size="xl" color="$textHint" />
          <Text textAlign="center" color="$textHeading" fontSize="$xl" fontWeight="semibold" mt="$4">
            {t('common.resolutionGuard.title')}
          </Text>
          <Text textAlign="center" color="$textBody" mt="$2" lineHeight="$md">
            {t('common.resolutionGuard.message', { width: minWidth, height: minHeight })}
          </Text>
          <Text textAlign="center" color="$textSubtle" mt="$4" size="xs">
            {t('common.resolutionGuard.currentResolution', {
              width: Math.floor(width),
              height: Math.floor(height),
            })}
          </Text>
        </Box>
      </Center>
    </Box>
  );
};

export default ResolutionGuard;
